import { useState } from 'react'
import { triggerRevalidation } from '@/lib/utils'
import { BlockEditor } from '@/components/block-editor/block-editor'
import {
  useHomepageSections,
  useUpdateHomepageSections,
  type BlockConfig,
} from '@/hooks/use-homepage'

export default function HomepageSettingsPage() {
  const { data: initialBlocks = [], isLoading } = useHomepageSections()
  const updateBlocks = useUpdateHomepageSections()
  const [saved, setSaved] = useState(false)

  function handleSave(blocks: BlockConfig[]) {
    updateBlocks.mutate(blocks, {
      onSuccess: async () => {
        setSaved(true)
        setTimeout(() => setSaved(false), 3000)
        await triggerRevalidation('tenant-theme')
      },
    })
  }

  if (isLoading) return <p className="text-muted-foreground">Memuat...</p>

  return (
    <BlockEditor
      pageTitle="Homepage"
      pageDescription="Atur block yang ditampilkan di halaman utama publik, beserta urutan dan konfigurasinya."
      initialBlocks={initialBlocks}
      onSave={handleSave}
      isSaving={updateBlocks.isPending}
      saveError={updateBlocks.error as Error | null}
      saved={saved}
      listenToRouterState
    />
  )
}
